import { render, staticRenderFns } from "./schemeDetails.vue?vue&type=template&id=501dc946&scoped=true&"
import script from "./schemeDetails.vue?vue&type=script&lang=js&"
export * from "./schemeDetails.vue?vue&type=script&lang=js&"
import style0 from "./schemeDetails.vue?vue&type=style&index=0&id=501dc946&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501dc946",
  null
  
)

export default component.exports